<template>
<div class="chapter">
<div class="inner_page">
<p><a id="als"></a></p>
<div class="fmhT">ALSO BY TAMAS DOBOZY</div>
<div class="fmtx1"><i>When X Equals Marylou</i></div>
<div class="fmtx1"><i>Last Notes and Other Stories</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tama_9781571318879_oeb_als_r1.vue?5ebac4d4